import ASummaryItemHeader from './index.vue';

ASummaryItemHeader.install = app => {
  app.component(ASummaryItemHeader.name, ASummaryItemHeader);
};

export default ASummaryItemHeader;
